
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case",
      function () {
        return require("private-next-pages/case.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case"])
      });
    }
  